import React from 'react'
import PropTypes from 'prop-types';
import css from './InputCalendar.module.scss'
import Calendar01 from '../../Icons/Calendar01'

const InputCalendar = ({
  label,
  id,
  value,
  onChange,
  type,
  required = false,
  disabled = false,
  min,
  max,
  error,
  size,
  ...rest
}) => {
  return (
    <div className={css.inputContainer}>
      <label className={css.label}>
        {label}
        {required && <span className={css.required}>*</span>}
      </label>
      <div className={css.inputWrapper}>
        <div className={css.iconContainer}>
          {<Calendar01 color="var(--primary-color)"/>}
        </div>
        <input
          type={type ?? "date"}
          id={id}
          value={value}
          onChange={onChange}
          min={min}
          max={max}
          disabled={disabled}
          className={`${css.input} ${error ? css.error : ''} ${size === 'small' ? css.small : ''}`}
          {...rest}
        />
      </div>
      {error && <span className={css.errorMessage}>{error}</span>}
    </div>
  )
}

InputCalendar.propTypes = {
  label: PropTypes.string,
  type: PropTypes.string,
  onChange: PropTypes.func,
  size: PropTypes.oneOf(['small']),
};

export default InputCalendar;
